import { Injectable } from '@angular/core';
import { PoolsMicroservice } from './microservices/pools.microservice';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { createQueryString } from 'utils/create-query-string';
import { MatDialog } from '@angular/material/dialog';
import { LoadingDialogComponent, loadingDialogConfig, LoadingDialogInput } from 'components/dialogs/loading-dialog/loading-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class UnderutilizationService {

  private hasError = new BehaviorSubject<{ message: string, type: 'generic' | 'unsaved' | null }>({ message: '', type: null });

  public showServerError$ = this.hasError.asObservable();

  public attemptRetry$ = new Subject();

  /**
   * Keep track of subscriptions to attemptRetry$
   * There should only be one subscription at a time so only the most
   * recent retry should occur
   */
  private retrySubscription?: Subscription;
   private defaultParams: any = {
      limit: 25,
      offset: 0,
      sortBy: 'createdon',
      direction: 'asc'
    }
  constructor(private api: PoolsMicroservice,private dialog: MatDialog) { }

  public getPoolConsumption(params:any): Observable<any> {
      const path = `underutilization`;
      return this.api.post(path,params);
    }

    //  public createPool(payload: CreatePoolPayload): Observable<CreatePoolResponse> {
    //     const path = 'pools';
    //     return this.api.post<CreatePoolResponse, CreatePoolPayload>(path, payload);
    //   }

    public getunderutilization(params: any): Observable<any> {
        const queryString = createQueryString({
          ...this.defaultParams,
          ...params
        });
        const path = `underutilization${queryString}`;
    
        return this.api.get(path);
      }

       public updatePoolConStatus(id: string, status: any): Observable<any> {
          const path = `underutilization/${id}/statusupdate`;
          return this.api.patch<any, any>(path, { status : status });
        }


        public getPoolConsumptionById(params: Partial<any>): Observable<any> {
            const path = `underutilization/${params.id}`;
        
            return this.api.get<any>(path);
          

        }
        public deletePoolConById(params: Partial<any>): Observable<any> {
            const path = `underutilization/${params.id}`;
        
            return this.api.delete<any>(path);
          }

         public triggerRetry(): void {
    this.attemptRetry$.next();
  }

         public setRetrySubscription(newSubscription: Subscription): void {
            if (this.retrySubscription) {
              this.retrySubscription.unsubscribe();
            }
            this.retrySubscription = newSubscription;
          }
        
          public showServerError(errorMessage: string = '', isGenericError?: boolean): void {
            this.hideSaving();
            this.hasError.next({ message: errorMessage, type: isGenericError ? 'generic' : 'unsaved' });
          }
        
          /**
           * Hides server error
           */
          public hideServerError(): void {
            this.hasError.next({ message: '', type: null });
          }

         public showSaving(): void {
    this.openSavingDialog();
  }

    public createEditPool(payload: any,id:any) {
      const path = `underutilization/${id}`;
      return this.api.patch(path, payload)
     
    }

  /**
   * Hides saving dialog
   */
  public hideSaving(): void {
    this.dialog.closeAll();
  }

   
    public hideLoading(): void {
      this.dialog.closeAll();
    }

      public showLoading(): void {
    this.openLoadingDialog();
  }
  
    
    private openSavingDialog(): void {
      this.dialog.open<LoadingDialogComponent, LoadingDialogInput>(
        LoadingDialogComponent, {
          ...loadingDialogConfig,
          data: {
            title: 'title.saving',
            subtitle: 'subtitle.pleaseWait',
          },
        });
    }
  
    /**
     * Open Loading Dialog
     */
    private openLoadingDialog(): void {
      this.dialog.open<LoadingDialogComponent, LoadingDialogInput>(
        LoadingDialogComponent, { ...loadingDialogConfig, data: {} });
    }
}
